import React from 'react';

/**
 * Large drop target below the last block — makes "drop at the end" easy.
 * Stays visually quiet; the last block's drop-indicator line is the cue.
 */
export const BottomDropSpace = () => <div className="bottom-drop-space" />;
